import { render, staticRenderFns } from "./SliderLanguages.vue?vue&type=template&id=d8cffc38"
import script from "./SliderLanguages.vue?vue&type=script&lang=js"
export * from "./SliderLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports